import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const workflowActionStep = defineStepConfig({
  type: "workflow_action",
  name: "Workflow Action",
  description:
    "Executes a reusable workflow action as a child workflow. Sockets mirror the selected action's public interface.",
  category: "Control Flow",
  inputSchema: z.record(z.string(), z.unknown()),
  outputSchema: z.record(z.string(), z.unknown()),
  configSchema: z.object({
    workflowDefinitionId: z
      .string()
      .uuid()
      .optional()
      .describe("Reusable workflow action to execute"),
  }),
  emits: [] as const,
  execution: {
    startToCloseTimeout: "10 minutes",
  },
});
